module.exports = __webpack_public_path__ + "profile-img.png";


//////////////////
// WEBPACK FOOTER
// ../shared-components/src/assets/images/profile-img.png
// module id = 488
// module chunks = 0